module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    ref: "tocPos",
    staticClass: "extend",
    attrs: {
      "id": _vm.title
    }
  }, [_c('span', {
    staticClass: "pkg"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "onMouseOver": "this.style.textDecoration = 'underline'",
      "onMouseOut": "this.style.textDecoration = ''"
    },
    on: {
      "click": _vm.tocBoxShow
    }
  }, [_vm._v(_vm._s(_vm.title) + "\n\t"), ('ja' == _vm.$i18n.locale) ? [_c('md-tooltip', {
    attrs: {
      "md-direction": "right"
    }
  }, [_vm._v("クリックするとタイトル一覧を表示します")])] : _vm._e()], 2), _vm._v(" "), (_vm.$store.state.enableOptionInfoLink) ? _c('div', {
    staticStyle: {
      "float": "left",
      "padding-left": "30px",
      "text-align": "left",
      "font-size": "small"
    }
  }, [_c('a', {
    staticClass: "link-info",
    staticStyle: {
      "color": "#3673ac"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toOptionInfo
    }
  }, [_vm._v("価格・スペック情報確認")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    style: (_vm.borderStyle)
  }, [_vm._l((_vm.children), function(c, index) {
    return [(c.nodeName.toLowerCase() != 'name') ? _c('simple-element', {
      attrs: {
        "el": c
      }
    }) : _vm._e()]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1642e42a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Selection.vue
// module id = 451
// module chunks = 1